/**
 * TanStack Router: /my-courses
 *
 * This route file was auto-generated by the route generation script.
 * Component: MyCoursesPage
 * Layout: Authenticated (_auth)
 *
 * @see scripts/generate-routes.ts
 * @see docs/architecture/tanstack-router-migration-architecture.md
 */
import { createFileRoute } from '@tanstack/react-router'
import MyCoursesPage from '@/app/my-courses/page'

/**
 * Route: /my-courses
 * Layout: _auth (authenticated)
 * Component: MyCoursesPage
 */
export const Route = createFileRoute('/_auth/my-courses')({
  component: MyCoursesPage,
})
